<template>
  <div>

    <div style="margin: 20px">
      请将下面的四位验证码和有效证件出示给工作人员
      <br>
      验证码五分钟内有效
    </div>
    <div style="font-size: 70px">
      {{ verifyCode }}
    </div>

    <el-button type="primary" @click="onNewCode">刷新验证码</el-button>

    <br>

    <el-tag style="margin: 20px" type="warning" v-if="bindInfo.bindType==='TeacherUnverified'">正在等待验证..</el-tag>
    <el-tag style="margin: 20px" type="success" v-if="bindInfo.bindType==='TeacherVerified'">验证成功</el-tag>
  </div>


</template>

<script>
import axios from '@/utils/request'

export default {
  name: 'Home',
  data() {
    return {
      verifyCode: "请等待",
      intervalCode: 0,
      bindInfo: {}
    }
  },
  methods: {

    onNewCode() {
      axios.post("/newVerifyCode").then(res => {
        this.verifyCode = res.data.code
      })
    }
  },
  mounted() {
    this.intervalCode = setInterval(() => {
      axios.post("/getBindInfo").then(res => {
        this.bindInfo = res.data.bindInfo
      })
    }, 1000)
  },
  created() {
    this.onNewCode()
  },
  destroyed() {
    clearInterval(this.intervalCode)
  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
